import { render } from "./TheDialogChangePassword.vue?vue&type=template&id=672299ce&scoped=true&ts=true"
import script from "./TheDialogChangePassword.vue?vue&type=script&lang=ts"
export * from "./TheDialogChangePassword.vue?vue&type=script&lang=ts"

import "./TheDialogChangePassword.vue?vue&type=style&index=0&id=672299ce&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src317777935/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672299ce"]])

export default __exports__